/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FooterSubscribe_viewer = {
    readonly user?: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": "FooterSubscribe_viewer";
};
export type FooterSubscribe_viewer$data = FooterSubscribe_viewer;
export type FooterSubscribe_viewer$key = {
    readonly " $data"?: FooterSubscribe_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FooterSubscribe_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FooterSubscribe_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '0b4835e8d59ed6347993a9029db90a8d';
export default node;
